export interface ServerVendorAccountList {
  accounts: ServerVendorAccount[];
  message: string;
  status: number;
}

export interface ServerVendorAccount {
  ACTIVATION_DATE: string | boolean;
  ADMIN_PERMISSIONS: boolean | boolean;
  AMAZON_VENDOR_SERVICE_EMAIL: string | null;
  AMAZON_VENDOR_SERVICE_NAME: string | null;
  AUDIT_USER: string | null;
  AVC_DATA_PULL_STATUS: string | null;
  AVC_PAYMENT_TERMS: string | null;
  AVC_PULL_STATUS_ID: number | null;
  AVC_USERS: string;
  CATEGORY: string | null;
  CB_PROCESSOR_ID: number | null;
  CB_PROCESSOR_USER_ID: string | null;
  CHARGEBACKS_PROCESSOR: string | null;
  CREATED: string;
  DEACTIVATION_DATE: null;
  DEFAULT_AVC_USER: string;
  GMV: string | null;
  ID: number;
  MANUAL_FILING_USER: string | null;
  NAME: string;
  PRICE_CLAIM_PROCESSING_STATUS: string | null;
  RECOVERY_POTENTIAL: string | null;
  /** JSON stringified in server response, must be parsed */
  SCOPES: ServerVendorAccountScopeInfo[] | null;
  SHIPPING_ID: number | null;
  SHORTAGE_LAG: string | null;
  SHORTAGE_PROCESSING_STATUS: string | null;
  STATUS: "active" | "inactive";
  VENDOR_ID: number;
  VENDOR_MANAGER_EMAIL: string | null;
  VENDOR_MANAGER_NAME: string | null;
  VENDOR_MANAGER_PERMISSION: string | null;
  WHITE_LABELED_ACCOUNT: string | null;
  MINIMUM_CHARGEBACKS_AMOUNT_LOCAL_CURRENCY: string | null;
}

export enum ServerScopeName {
  PRICE_CLAIMS = "price_claims",
  SHORTAGES = "shortages",
  CHARGEBACKS = "chargebacks",
  ACCRUALS = "accruals",
  VENDOR_RETURNS = "vendor_returns",
}

export interface ServerVendorAccountScopeInfo {
  scope_name: ServerScopeName;
  activation_date: string | null;
  deactivation_date: string | null;
}
